module.exports = __webpack_public_path__ + "media/sample.f56dde4d.mp4";